import { Routes } from '@angular/router';
import { NotFoundComponent } from 'src/shared/components/notfound/notfound.component';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { accountRoutes } from './account/account-routing';
import { appointmentsRoutes } from './appointments/appointments-routing';
import { calendarRoutes } from './calendar/calendar-routing';
import { consultationRoutes } from './consultations/consultations-routing';
import { dashboardRoutes } from './dashboard/dashboard-routing';
import { onboardingRoutes } from './onboarding/onboarding-routing';
import { trialConsultationRoutes } from './trial-consultation/trial-consultation.routing';
import { usaRoutes } from './usa/usa-routing';

export const pmsRoutes: Routes = [
  {
    path: 'checkaccess',
    loadComponent: () =>
      import('src/shared/components/authentication/checkstaffaccess/checkstaffaccess.component').then(
        (x) => x.CheckStaffAccessComponent
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('src/shared/components/authentication/login/login.component').then((x) => x.LoginComponent),
    title: 'Joii PMS - Login',
  },
  {
    path: 'register',
    loadComponent: () =>
      import('src/shared/components/authentication/register/register.component').then((x) => x.RegisterComponent),
    title: 'Joii PMS - Register',
  },
  {
    path: 'forgottenpassword',
    loadComponent: () =>
      import('src/shared/components/authentication/forgottenpassword/forgottenpassword.component').then(
        (x) => x.ForgottenPasswordComponent
      ),
    title: 'Joii PMS - Forgotten Password',
  },
  {
    path: 'tenants/:redirectUrl',
    loadComponent: () =>
      import('src/shared/components/authentication/tenants/tenants.component').then((x) => x.TenantsComponent),
  },
  {
    path: 'unauthorised',
    loadComponent: () =>
      import('src/shared/components/notauthorised/notauthorised.component').then((x) => x.NotAuthorisedComponent),
  },
  { path: '', redirectTo: 'checkaccess', pathMatch: 'full' },
  {
    path: '',
    children: [
      ...onboardingRoutes,
      ...dashboardRoutes,
      ...consultationRoutes,
      ...calendarRoutes,
      ...appointmentsRoutes,
      ...accountRoutes,
      ...trialConsultationRoutes,
      ...usaRoutes,
    ],
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
    title: 'Joii PMS - Page Not Found',
  },
  { path: '**', redirectTo: 'notfound' },
];
